import {keyframes} from '@chakra-ui/react';

export const arrowAnimation = keyframes`
  from {right: -20px;}
  to {right: -25px;}
`;
